<template>
  <div>
    <div class="padding-container-sm">
      <v-page-header>
        <div slot="header">
          <div class="row">
              <div class="d-flex searchFilter col-8">
                <b-input-group size="md border-right flex-grow-1">
                  <b-input-group-text slot="append" class="bg-white">
                    <strong><i class="ion-md-search"/></strong>
                  </b-input-group-text>
                  <b-form-input
                    class="border-right-0"
                    :value="filter.searchValue"
                    placeholder="Search for patient or ID"
                    @keyup.enter.native="onSearchText"
                    @blur.native="onSearchText"
                  />
                </b-input-group>
                <b-input-group size="md">
                  <v-date-picker
                    className="mb-0 datePicker"
                    :value="filter.alertDate"
                    position="bottom"
                    @onChange="onFilterDateChange"
                    class="mb-0 w-100"
                  />
                </b-input-group>
              </div>
              <div class="btn btn-link" @click="resetFilters">
                <strong><i class="ion-md-refresh mr-1"/></strong>Reset
              </div>
            </div>
        </div>
      </v-page-header>
      <v-table
        :options="tableProps"
        :total-count="Number(totalCount)"
        :data="alerts"
      >
        <template slot="name" slot-scope="slotProps">
          <div class="align-items-center d-flex patient-name-content">
            <img
              :src="
                require(`@/assets/image/${
                  slotProps.data.datum && slotProps.data.datum.gender === 'male'
                    ? 'boy'
                    : 'girl'
                }.svg`)
              "
              width="35"
              height="35"
              :alt="slotProps.data.datum.first_name"
              v-b-tooltip.hover
              :title="slotProps.data.datum.first_name"
            />
            <div
              class="d-flex flex-column justify-content-center align-items-center"
              v-if="slotProps"
            >
              <span>
                {{ slotProps.data.datum.first_name | capitalizefirst }}
                {{ slotProps.data.datum.last_name | capitalizefirst }}
              </span>
              <span
                class="btn btn-sm btn-link"
                @click="viewCarePlanDetails(slotProps.data.datum)"
                >View Careplan</span
              >
              <span v-if="permissions.patientmessage && permissions.patientmessage.view" class="btn btn-link" @click="redirectToMessage(slotProps.data.datum.mr_id)">
                Send Message
              </span>
            </div>
          </div>
        </template>
        <template slot="description" slot-scope="slotProps">
          <div
            class="d-flex flex-row justify-content-around alertCell"
            v-for="alert in slotProps.data.datum.alert"
            :key="alert.alert_id"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-center w-50 p-2 col"
            >
              <span class="unassigned w-100 text-break">
                <b>
                  {{ alert.desc ? alert.desc.split(":")[0] : "" }}
                </b>
                <b v-if="alert.desc_value"> - {{ alert.desc_value }} </b>
              </span>
              <span class="align-items-center d-flex">
                <img
                  src="@/assets/image/clock.svg"
                  width="15"
                  height="15"
                  alt=""
                  class="mr-1"
                  v-if="alert.is_after_hour"
                />
                {{ dateFormate(getFormattedDate(alert.created_at, dateTime)) }}
              </span>
              <span
                v-if="
                  slotProps.data.datum &&
                    slotProps.data.datum.alert[0].viewProgressstatus
                "
                @click="viewPatientProgress(slotProps.data.datum)"
                class="btn btn-link"
              >
                View Progress
              </span>
            </div>
            <div
              class="d-flex flex-column justify-content-center align-items-center w-50 p-2 col"
            >
              {{
                alert &&
                  alert.mobile_no | mobileformat(alert && alert.country_code)
              }}
              <span>
                {{ alert && alert.email }}
              </span>
            </div>
          </div>
        </template>
        <template slot="status" slot-scope="slotProps">
          <div
            v-if="slotProps"
            class="d-flex flex-column justify-content-between align-items-center p-2"
          >
            <span
              :class="slotProps.data.datum.status ? 'resolved' : 'unresolved'"
            >
              <div
                v-if="slotProps.data.datum.status"
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <span
                  v-if="slotProps.data.datum && slotProps.data.datum.status"
                  @click="viewResolvedNotes(slotProps.data.datum)"
                  class="btn btn-link px-0"
                >
                  view note
                </span>
              </div>
            </span>
          </div>
        </template>
        <template slot="actions" slot-scope="slotProps">
          <div
            v-if="slotProps.data.datum"
            class="d-flex justify-content-around"
          />
          <div v-if="slotProps.data.datum && !slotProps.data.datum.status">
            <button
              class="btn btn-sm btn-primary"
              @click="onResolve(slotProps.data.datum)"
            >
              Resolve
            </button>
            <div  v-if="slotProps.data.datum.resolved_alert_id" class="py-1 text-danger">(Pending)</div>
          </div>
        </template>
        <template slot="alert-info-header">
          <div class="d-flex flex-row justify-content-around">
            <div>
              Alert Triggered
            </div>
            <div>
              Contact
            </div>
          </div>
        </template>
      </v-table>
    </div>
    <v-patient-progress
      ref="patientProgress"
      @onViewProgressCancel="onViewProgressCancel"
    />
    <v-resolution ref="resolution" :onResolve="fetchAlerts" />
    <v-loader :isLoading="isLoading || isProtocolLoading || isResolutionLoading" />
  </div>
</template>

<script>
import VTable from "@/components/table/index.vue";
import { mapGetters } from "vuex";
import VPageHeader from "@/components/pageheader/PageHeader.vue";
import VPatientProgress from "@/components/patient/PatientProgress.vue";
import VResolution from "@/components/resolution/Resolution.vue";
import VLoader from "@/components/loader/index.vue";
import moment from "moment-timezone";
import dateFormate from "@/mixins/dateFormate";
import constants from "@/constants/app.properties";


export default {
  name: "Alerts",
  components: {
    VTable,
    VPatientProgress,
    VPageHeader,
    VResolution,
    VLoader
  },
  mixins: [dateFormate],
  data() {
    return {
      patient: {},
      alertDetails: [],
      filter: {
        status: this.status,
        searchValue: "",
        limit: 10,
        pageNo: 1,
        filterType: this.status.toLowerCase(),
        alertDate: this.getFormattedDate()
      },
      roles: {
        CARE_AUTHOR: "Author",
        CARE_NAVIGATOR: "Navigator"
      },
      statusProps: {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "status"
            },
            dataKey: "email",
            dataType: String,
            label: "Status"
          },
      actionProps: {
        headerCellProps: {
          class: "header-cell"
        },
        cellProps: {},
        cellSlot: {
          name: "actions"
        },
        disablePadding: false,
        label: "Actions"
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {
              class: "text-left"
            },
            cellSlot: {
              name: "name"
            },
            dataKey: "first_name",
            dataType: String,
            label: "Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "mr_id",
            dataType: String,
            label: "ID"
          },
          {
            headerCellProps: {
              class: "header-cell",
              colspan: 2
            },
            headerCellSlot: {
              name: "alert-info-header"
            },
            cellSlot: {
              name: "description"
            },
            cellProps: {
              colspan: 2,
              class: "alertCol"
            },
            dataKey: "description",
            dataType: String,
            label: "Alert Triggered"
          },
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: "All users"
      }
    };
  },
  props: {
    status: {
      type: String,
      required: true,
      default: ''
    }
  },
  beforeMount() {
    if (this.status == 'UnResolved') {
      this.tableProps.columns.push(this.actionProps);
    } else {
      this.tableProps.columns.push(this.statusProps);
    }
  },
  computed: {
    ...mapGetters({
      alerts: "alert/getAlerts",
      alertCount: "alert/getAlertCount",
      totalCount: "alert/getTotalCount",
      permissions: "auth/getModulePermissions",
      isLoading: "alert/getIsLoading",
      isProtocolLoading: "managementProtocolTemplate/getLoading",
      isResolutionLoading: "alert/getIsResolutionLoading",
      managementProtocolTemplate:
        "managementProtocolTemplate/getManagementProtocolTemplate"
    })
  },
  watch: {
    filter: {
      handler: "fetchAlerts",
      immediate: true
    },
    managementProtocolTemplate: {
      handler: "fetchProtocolTemplate"
    }
  },

  methods: {
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    onSearchText(event) {
      this.filter = {
        ...this.filter,
        pageNo: "1",
        searchValue: event.target.value
      };
    },
    onFilterDateChange(value) {
      this.filter = {
        ...this.filter,
        alertDate: value
      };
    },
    fetchAlerts() {
      this.$store.dispatch("alert/view", this.filter);
    },
    onControlClick(type, id) {
      if (type === "Delete") {
        const content = {
          title: "Delete User",
          message: "Do you want to delete this user?"
        };
        this.conFirmAlert(
          content,
          () => {
            const data = { id, is_active: false };
            this.$store.dispatch("user/remove", data);
          },
          () => {}
        );
      }
    },
    getHoursFromNow(startTime) {
      const start = moment(startTime);
      const end = moment();
      const timediffms = end - start; // difference in ms
      const duration = moment.duration(timediffms);
      // let hours = duration._data.days*24 + duration._data.hours;
      // let min = duration._data.minutes;
      let hours = duration.days() * 24 + duration.hours();
      const min = duration.minutes();
      const days = hours > 24 ? hours / 24 : 0;
      hours = hours > 24 ? hours % 24 : hours;
      const hasManyDays = days > 1;
      const hasManyHours = hours > 1;
      const hasManyMinutes = min > 1;
      return `${days ? `${Math.floor(days)} day${hasManyDays ? "s" : ""}` : ""}
       ${hours} hour${hasManyHours ? "s" : ""} 
       ${min} minute${hasManyMinutes ? "s" : ""} ago`;
    },
    onResolve(patientDetails) {
      this.alertDetails = patientDetails.alert;
      if (patientDetails.resolved_alert_id) {
        this.$refs.resolution.showResolutionToAlert(patientDetails.alert, {}, 'edit');
        this.getUpdatedResolutionData(patientDetails, false);
      } else {
        this.$store.dispatch('managementProtocolTemplate/getProtocolList', true);
      }
    },
    redirectToMessage(mrId) {
      const data = { mrId, isSelectedPatient: true };
      this.$store.dispatch('patient/setPatientDataToMsg', data);
      this.$router.push({ name: 'message.index' });
    },
    getUpdatedResolutionData(patientDetails, isGetProtocol) {
      const { patient_id, careplan_id, resolved_alert_id } = patientDetails;
      const { created_at } = patientDetails.alert[0];
      const data = {
        resolvedId: resolved_alert_id,
        patientId: patient_id,
        alertDate: this.getFormattedDate(created_at, constants.DATE_FORMAT),
        carePlanId: careplan_id,
        };
      this.$store.dispatch('managementProtocolTemplate/getProtocolList', isGetProtocol);
      this.$store.dispatch("alert/getResolvedNotes", data);
    },
    fetchProtocolTemplate(value) {
      if (value) {
        this.$refs.resolution.showResolutionToAlert(this.alertDetails, value, 'add');
      }
    },
    viewCarePlanDetails(alertDetails) {
      const id = alertDetails.careplan_id;
      this.$router.push({
        name: "careplan.view",
        params: { id }
      });
    },
    viewPatientProgress(patient) {
      // eslint-disable-next-line camelcase
      const { first_name, mobile_no } = patient;
      // eslint-disable-next-line camelcase
      patient.first_name = first_name;
      // eslint-disable-next-line camelcase
      patient.mobile_no = mobile_no;

      this.patient = patient;
      this.patient.id = patient.patient_id;
      this.$refs.patientProgress.viewPatientProgress(patient);
    },
    onViewProgressCancel() {
      this.patient = {};
    },
    viewResolvedNotes(patientDetails) {
      this.$refs.resolution.showResolvedNotesToAlert(patientDetails);
      this.getUpdatedResolutionData(patientDetails, false);
    },
    resetFilters() {
      this.filter = {
        status: this.status,
        filterType: this.status.toLowerCase(),
        searchValue: "",
        limit: 10,
        pageNo: 1,
        alertDate: this.getFormattedDate()
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<style lang="scss">
@import "./searchBar.scss";
</style>
